import React from 'react'
import styles from './aboutSection.module.css'
import { useNavigate } from 'react-router-dom'

const AboutSection = () => {
    const navigate = useNavigate();
    return (
        <section className={styles.aboutContainer}>
            <div className={styles.backdropOrb} aria-hidden="true"></div>
            <div className={styles.aboutCol1}>
                <span className={styles.eyebrow}>About Electrowiz</span>
                <h2>Smarter sourcing,<br /><em>built for momentum.</em></h2>
                <div className={styles.highlights}>
                    <div className={styles.highlightItem}>
                        <span className={styles.highlightIcon}>01</span>
                        <span>Built for manufacturers</span>
                    </div>
                    <div className={styles.highlightItem}>
                        <span className={styles.highlightIcon}>02</span>
                        <span>Made in Bangalore</span>
                    </div>
                </div>
            </div>
            <div className={styles.aboutCol2}>
                <p className={styles.introText}>
                    Electrowiz is a new-age sourcing platform built for manufacturers, EMS companies, and traders. From BOM uploads to urgent procurement, we simplify every step of the electronics sourcing journey—faster, smarter, and more organized.
                </p>
                <p className={styles.supportingText}>We’re proudly made in Bangalore and built for India’s fast-moving industry. Procurement made smart, so you can focus on building the future.</p>
                <button onClick={() => navigate("/aboutUs")} className={styles.knowMoreBtn}>
                    Discover our story
                    <span aria-hidden="true">→</span>
                </button>
            </div>
        </section>
    )
}

export default AboutSection
